import React from 'react';
import { Switch, Route, Redirect } from 'react-router';
import styled from 'styled-components';
import { AccountsTable } from './components/accountTable';
import { BetsTable } from './components/betTable';
import SubNavBar from './components/subnav';
import { TotalsTable } from './components/totalsTable';
import { TransfersTable } from './components/transfersTable';

const BackgroundContainer = styled.div`
  flex: 1;
`;

const PageContainer = styled.div`
  padding: 1rem;
  flex: 1;
`;

export const CustomerBetting = () => {
  return (
    <BackgroundContainer>
      <SubNavBar />
      <PageContainer>
        <Switch>
          <Route path="/betting/accounts">
            <AccountsTable />
            <TransfersTable />
          </Route>
          <Route path="/betting/bets">
            <BetsTable />
          </Route>
          <Route path="/betting/totals">
            <TotalsTable />
          </Route>
          <Route render={() => <Redirect to="/betting/accounts" />} />
        </Switch>
      </PageContainer>
    </BackgroundContainer>
  );
};
